
// RelatorioVendasModal.js

import React, { useState } from 'react';
import { Modal, Typography, Button } from '@mui/material';
//import Axios from 'axios';
import api from '../config/axiosConfig';

import './RelatorioVendasModal.css';

const RelatorioVendasModal = ({ open, handleClose, idVenda, codVenda, codCli }) => {
  const [dataInicial, setDataInicial] = useState('');
  const [dataFinal, setDataFinal] = useState('');

  // Função para baixar o PDF
  const downloadPDF = (data, fileName) => {
    const blob = new Blob([data], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  };

  // Função auxiliar para formatar datas de "yyyy-MM-dd" para "dd/MM/yyyy"
  const formatarData = (data) => {
    if (!data) return '';
    const partes = data.split('-');
    if (partes.length !== 3) return data; // Retorna como está se o formato for inesperado
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  };

  const handleImprimirVendaPagina = async () => {
    try {
      const response = await api.get('/vendas/relatorio/pagina', {
        params: { idVenda }, // Usando o idVenda passado como prop
        responseType: 'blob'
      });
      // Nome do PDF já definido no backend, mas adicionamos o codvenda aqui
      downloadPDF(response.data, `Relatório da Venda ${codVenda}.pdf`);
    } catch (error) {
      console.error('Erro ao gerar relatório de venda da página', error);
    }
  };

  const handleImprimirVendasCliente = async () => {
    try {
      const response = await api.get('/vendas/relatorio/cliente', {
        params: {
          codcli: codCli, // Use o código do cliente passado como prop
          dataInicial: dataInicial,
          dataFinal: dataFinal,
        },
        responseType: 'blob'
      });

      // Nome do PDF atualizado conforme o backend
      const fileName = `Relatório de Vendas Cliente ${codCli} de ${formatarData(dataInicial)} a ${formatarData(dataFinal)}.pdf`;
      downloadPDF(response.data, fileName);
    } catch (error) {
      console.error('Erro ao gerar relatório de vendas do cliente', error);
    }
  };

  const handleImprimirTodasVendas = async () => {
    try {
      const response = await api.get('/vendas/relatorio/todos', {
        params: {
          dataInicial: dataInicial,
          dataFinal: dataFinal,
        },
        responseType: 'blob'
      });
      
      const fileName = `Relatório de Todas as Vendas de ${formatarData(dataInicial)} a ${formatarData(dataFinal)}.pdf`;
      downloadPDF(response.data, fileName);
    } catch (error) {
      console.error('Erro ao gerar relatório de todas as vendas', error);
    }
  };

  if (!open) return null;

  return (
    <Modal open={open} onClose={() => { 
        // Limpa os estados quando fechar o modal
        setDataInicial(''); 
        setDataFinal(''); 
        handleClose(); 
      }}>
      <div className="modal">
        <div className="modal-content">
          <span className="close" onClick={() => { 
              setDataInicial(''); 
              setDataFinal(''); 
              handleClose(); 
            }}>&times;</span>
          <Typography variant="h6" align="center">Imprimir Relatório de Vendas</Typography>

          {/* Botão Venda Atual Centralizado */}
          <div className="button-center">
            <Button className="salvando" onClick={handleImprimirVendaPagina}>
              Venda Atual
            </Button>
          </div>

          {/* Seção de Período */}
          <Typography variant="subtitle1" className="periodo-title">
            Período:
          </Typography>
          <div className="date-container">
            <input
              type="date"
              value={dataInicial}
              onChange={(e) => setDataInicial(e.target.value)}
              className="date-input"
            />
            <input
              type="date"
              value={dataFinal}
              onChange={(e) => setDataFinal(e.target.value)}
              className="date-input"
            />
          </div>

          {/* Botões Vendas Cliente e Todas as Vendas Alinhados */}
          <div className="button-container">
            <Button 
              className="salvando" 
              onClick={handleImprimirVendasCliente}
              disabled={!dataInicial || !dataFinal || !codCli}
            >
              Vendas Cliente
            </Button>
            <Button 
              className="salvando" 
              onClick={handleImprimirTodasVendas}
              disabled={!dataInicial || !dataFinal}
            >
              Todas Vendas
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RelatorioVendasModal;